import { render, staticRenderFns } from "./ChiefsupervisorQuerylogsManagerWrapper.vue?vue&type=template&id=382e56a5&"
import script from "./ChiefsupervisorQuerylogsManagerWrapper.vue?vue&type=script&lang=js&"
export * from "./ChiefsupervisorQuerylogsManagerWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ChiefsupervisorQuerylogsManagerWrapper.vue?vue&type=style&index=0&id=382e56a5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports